<template>
  <router-view />

  <div id="cart-offcanvas" uk-offcanvas="overlay: true; flip: true">
    <div class="uk-offcanvas-bar cart-panel uk-flex uk-flex-column">

      <div class="cart-panel__header uk-flex uk-flex-between uk-flex-middle">
        <div>
          <span class="eyebrow">Your order</span>
          <h2>Cart <small>{{ cartCount }} kits</small></h2>
        </div>
        <button class="uk-offcanvas-close cart-panel__close" type="button" aria-label="Close cart" uk-close></button>
      </div>

      <div class="uk-flex-1 uk-overflow-auto cart-panel__body">
        <div v-if="!cart.length" class="cart-empty-state">
          <span uk-icon="icon: cart; ratio: 1.6"></span>
          <h3>Your cart is empty</h3>
          <p>Add wholesale kits from the shop to begin an order.</p>
        </div>

        <ul class="cart-items" v-else>
          <li v-for="ci in cart" :key="ci.key" class="cart-item">
            <div class="uk-width-expand uk-margin-small-right">
              <div class="cart-item__name">{{ ci.productName }}</div>
              <div class="cart-item__variation" v-if="ci.variationName">{{ ci.variationName }}</div>

              <div class="cart-item__quantity">
                <span>${{ formatMoney(ci.price) }} ×</span>
                <input
                  class="uk-input qty-input-inline"
                  type="number"
                  min="1"
                  max="9999"
                  step="1"
                  pattern="[0-9]*"
                  v-model.number="ci.quantity"
                  @input="sanitizeQty(ci)"
                  @blur="sanitizeQty(ci)"
                />
              </div>
            </div>
            <div class="cart-item__total">
              <strong>${{ formatMoney(ci.price * ci.quantity) }}</strong>
              <button
                type="button"
                aria-label="Remove item"
                uk-icon="icon: trash"
                @click="remove(ci.key)"
              ></button>
            </div>
          </li>
        </ul>
      </div>

      <div class="cart-panel__footer">
        <div class="cart-total">
          <span>Subtotal</span>
          <strong>${{ formatMoney(cartSubtotal) }}</strong>
        </div>
        <p>Shipping and tax are calculated at checkout.</p>
        <button
          :disabled="!cart.length"
          class="uk-button uk-button-primary uk-width-1-1 uk-button-large"
          v-if="cartCount"
          @click="goToCheckoutAndClose"
        >
          Continue to checkout
        </button>
      </div>

    </div>
  </div>    

</template>

<script>
import { totalCartKits } from '@/utils/cart';

export default {
  data() {
    return {
      cart: [],
    };
  },
  computed: {
    cartCount() {
      return totalCartKits(this.cart);
    },
    cartSubtotal() {
      return this.cart.reduce((sum, i) => sum + (Number(i.price) * Number(i.quantity)), 0);
    }
  },
  mounted() {
    this.syncFromStorage();
    window.addEventListener('storage', this.onStorage);
    window.addEventListener('ucari:cart-updated', this.syncFromStorage);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.onStorage);
    window.removeEventListener('ucari:cart-updated', this.syncFromStorage);
  },
  methods: {
    // reflect localStorage (RetailerHeader is the source of truth)
    syncFromStorage() {
      try { this.cart = JSON.parse(localStorage.getItem('ucari_cart') || '[]'); }
      catch { this.cart = []; }
    },
    onStorage(e) {
      if (e.key === 'ucari_cart') this.syncFromStorage();
    },

    // delegate mutations to the global API provided by RetailerHeader
    remove(key) {
      window.ucariCart?.remove?.(key);
      this.syncFromStorage();
    },
    sanitizeQty(ci) {
      let q = Number(ci.quantity);

      if (!Number.isFinite(q) || q < 1) {
        q = 1;
      }

      ci.quantity = q;

      window.ucariCart?.update?.({
        key: ci.key,
        quantity: q
      });

      this.syncFromStorage();
    },
    formatMoney(cents) {
      return (Number(cents || 0) / 100).toFixed(2);
    },
    goToCheckoutAndClose() {
      window.ucariCart?.close?.();
      this.$router.push({ name: 'Checkout' });
    }
  }
};
</script>
